<template>
  <v-container fluid>
    <PageTitle>
      New Disclaimer
    </PageTitle>
    <v-form @submit.prevent="submit">
      <v-card class="mb-4">
        <v-card-text>
          <DisclaimerForm :form="form">
          </DisclaimerForm>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary">
            Save
          </v-btn>
          <v-btn :to="{name: 'admin.disclaimers.index'}">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <DisclaimerMockup :disclaimer="form">
    </DisclaimerMockup>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import DisclaimerForm from './components/DisclaimerForm.vue';
import disclaimerService from '../../services/disclaimerService';
import PageTitle from '../../components/PageTitle.vue';
import DisclaimerMockup from './components/DisclaimerMockup.vue';

export default {
  components: {DisclaimerMockup, PageTitle, DisclaimerForm},
  data() {
    return {
      form: new Form(disclaimerService.initForm()),
    }
  },
  computed: {},
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {

    },
    submit() {
      const form = this.form.data();
      form.presentations = this.form.presentations.map(p => p);
      this.form.post(`/api/disclaimers`, {data: form})
        .then(response => {
          this.$router.push({name: 'admin.disclaimers.index'});
        })
        .catch(err => {

        })
    }
  }
}
</script>
